




import { Vue, Component } from 'vue-property-decorator'

import Rooms from '@/components/Rooms.vue'

@Component({
  components: {
    Rooms
  }
})
export default class RoomsView extends Vue {
}
